export default {"src":"https://s.sylndr.com/c-c51c782/_next/static/media/bookedCarsIconBlack.f13e9cae.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};